import CommonDepartmentDrawer from './CommonDepartmentDrawer';

export default CommonDepartmentDrawer;
